import { useAppDispatch } from "hooks/hooks";
import { AiFillStar } from "react-icons/ai";
import { setSort } from "../main.slice";
import { HiMiniDevicePhoneMobile } from "react-icons/hi2";
import { TiThMenu } from "react-icons/ti";
import InfoTooltip from "components/Popup/InfoTooltip";

const ProjectHeaderRow = () => {
  const dispatch = useAppDispatch();
  const handleSort = (
    sortKey: string, typeOfValue: 'string' | 'boolean' | 'date'
  ) => {
    dispatch(setSort({ key: sortKey, typeOfValue: typeOfValue }));
  };

  return (
    <div className="row">
      <div className="col lowercase center separator-line clickable"
        onClick={() => handleSort("isFavourite", "boolean")}><AiFillStar size={18} />
      </div>
      <div className="col lowercase center clickable"
        onClick={() => handleSort("projectName", "string")}><span >Naziv projekta</span>
      </div>
      <div className="col lowercase center separator-line"><span></span></div>
      <div className="col lowercase center separator-line clickable"
        onClick={() => handleSort("type.name", "string")}><span>kategorija</span>
      </div>
      <div className="col lowercase center separator-line"><span>vrsta</span></div>
      <div className="col lowercase center separator-line"><span>Mesto</span></div>
      <div className="col lowercase center separator-line"><span>Naručilac</span></div>
      <div className="col lowercase center"><span>Vrednost proj.</span></div>
      <div className="col lowercase center separator-line"><span></span></div>
      <div className="col lowercase center separator-line clickable"
        onClick={() => handleSort("contractDate", "date")}><span>Datum ugovora</span>
      </div>
      <div className="col lowercase center separator-line"><span>Rok za završetak</span></div>
      <div className="col lowercase center separator-line"><span>Početak radova</span></div>
      <div className="col lowercase center separator-line"><span>Krajnji rok</span></div>
      <div className="col lowercase center separator-line"><span>Dana ostalo</span></div>
      <div className="col lowercase center separator-line"><span>završio</span></div>
      <InfoTooltip
        tooltip="za mobilnu app"
        classesProp="col lowercase center separator-line">
        <HiMiniDevicePhoneMobile size={13} />
      </InfoTooltip>
      <InfoTooltip
        tooltip="sakrij u menijima"
        classesProp="col lowercase center separator-line">
        <TiThMenu size={13} />
      </InfoTooltip>
      <div className="col lowercase center"><span>menadžer</span></div>
    </div>
  );
};

export default ProjectHeaderRow;
